export enum OrganiserModule {
    EVENT_MANAGEMENT = 'EVENT_MANAGEMENT',
    LEAGUE_MANAGEMENT = 'LEAGUE_MANAGEMENT',
}